/***
 * @file:
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { SettingsService } from '@ithinkdt/shared/browser';
import { BaseAjaxService } from '@ithinkdt/shared/http';
import { Observable } from 'rxjs';

@Injectable()
export class FormSearchService extends BaseAjaxService {
  constructor(private settingsSrv: SettingsService, http: HttpClient) {
    super(http);
  }

  // ä¸ä¼ 
  uploadData(api, param?): Observable<any> {
    return this.postFile(api, param);
  }

  // æç´¢ä¸ææ¡
  searchSelect(api, param): Observable<any> {
    return this.post(api, param);
  }

  // è·åèªå®ä¹å­å¸æ¥å£çæå¡
  getUserdefineDictLists(api, param, resquestType = 'post') {
    if (typeof resquestType === 'boolean') {
      // å¼å®¹èçæ¬
      if (resquestType) {
        return this.post(api, param);
      } else {
        return this.postJson(api, param);
      }
    } else if (this[resquestType]) {
      return this[resquestType](api, param);
    } else {
      console.error(`Select component request "${resquestType}" method error`);
    }
  }
}
